export enum StatusLogGeral {
  Falha,
  Sucesso,
}
